import { setSession, getSession, saveLocal } from '../../utilites';
import {
  SET_CAR_BRAND,
  SET_CAR_MODEL,
  SET_BODY_TYPE,
  SET_PRODUCTION_YEAR_FROM,
  SET_PRODUCTION_YEAR_TO,
  SET_TRANSMISSION_TYPE,
  SET_ENGINE_TYPE,
} from '../actionsTypes';
import { CAR_BRAND_STATE } from '../../constants';

const initialState = getSession(CAR_BRAND_STATE) || {
  Brand: undefined,
  Model: undefined,
  BodyType: undefined,
  ProductionYearFrom: undefined,
  ProductionYearTo: undefined,
  TransmissionType: undefined,
  EngineType: undefined,
};

const searchCatalogReducer = (state = initialState, action) => {
  let newState;
  switch (action.type) {
    case SET_CAR_BRAND:
      newState = { ...state, Brand: action.payload, Model: undefined };
      setSession(CAR_BRAND_STATE, newState);
      saveLocal(CAR_BRAND_STATE, newState);
      return newState;
    case SET_CAR_MODEL:
      newState = { ...state, Model: action.payload };
      setSession(CAR_BRAND_STATE, newState);
      saveLocal(CAR_BRAND_STATE, newState);
      return newState;
    case SET_BODY_TYPE:
      newState = { ...state, BodyType: action.payload };
      setSession(CAR_BRAND_STATE, newState);
      return newState;
    case SET_PRODUCTION_YEAR_FROM:
      newState = { ...state, ProductionYearFrom: action.payload };
      setSession(CAR_BRAND_STATE, newState);
      return newState;
    case SET_PRODUCTION_YEAR_TO:
      newState = { ...state, ProductionYearTo: action.payload };
      setSession(CAR_BRAND_STATE, newState);
      return newState;
    case SET_TRANSMISSION_TYPE:
      newState = { ...state, TransmissionType: action.payload };
      setSession(CAR_BRAND_STATE, newState);
      return newState;
    case SET_ENGINE_TYPE:
      newState = { ...state, EngineType: action.payload };
      setSession(CAR_BRAND_STATE, newState);
      return newState;
    default:
      return state;
  }
};

export default searchCatalogReducer;
